<template>
  <div class="good">
    <div class="bg">
      <div class="container">
        <p class="title">挑选商品上架</p>
        <ul class="goodslist">
          <template  v-for="(item,index) in goodslist" >
            <li  class="box" :key="index" v-if="index<6" @click="setToPrice(item)" :data-goodid="item.goodsId">
            <div class="img">
              <img :src="item.goodsImg" alt="">
            </div>
            <div class="true" v-if="currentIndex===index?isTrue:''">
              <img src="../../../assets/images/active/choose.png" alt="">
            </div>
            <div class="putaway" v-if="item.saleStatus ===1?isPutaway:''">
              <div class="image">
                 <img src="../../../assets/images/active/shangjia.png" alt="">
              </div>
             
            </div>
            <p class="goodsname">{{item.goodsName}}</p>
          </li>
          </template>
        </ul>
      </div>
      <div class="again">还可以上架{{goodsCount}}个产品</div>
      <div class="btn" v-show="isShowBtn">
            <img src="../../../assets/images/active/login.png" alt="" class="btn_image">
            <p class="font">确认开店</p>
            <div class="mocen" @click="setShopname"></div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      ownerUserGuid: "",
      token: "",
      userguid: "",
      niakname: "",
      goodslist:[],
      platform:"",
      isTrue:true,//是否选中
      goodsCount:"",//还可以上架礼物数量
      isPutaway:true,//是否显示上架图标
      isShowBtn:true ,//是否显示上架按钮
      currentIndex:"",
    };
  },
  created(){
     document.getElementsByTagName("title")[0].innerText = "我是谜520表白商店";
    this.isShowBtn=false
     var u = navigator.userAgent,
      app = navigator.appVersion;
     var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
     var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isAndroid) {
      this.platform = 1;
    } else if (isiOS) {
      this.platform = 2;
    } else {
      this.platform = 1;
    }
    this.goodList()
  },
  methods:{
    setShopname(){
      this.$router.push("/setname")
    },
    setToPrice(item){
      if(this.goodsCount == 0) {
        return false //商品不可点击
      } 
      if(item.saleStatus == 1) {
        return false //商品不可点击
      }
     this.$router.push({path:"/setprice",query:{goodsid:item.goodsId,name:item.goodsName,img:item.goodsImg}})
    },
    goodList(){
      axios.post(this.$interfaces.getActivityLoveGoodsList,{
         userGuid: this.$store.state.userguid,
         token: this.$store.state.token,
         platform:this.platform
      }).then(res=>{
        // console.log(res)
        if(res.data.code == 400){
            this.$router.push({ path: "/login" });
            return
          }
        this.goodslist=res.data.data.goodsList
        this.goodslist.forEach((item,index)=>{
          this.goodsId=item.goodsId
          this.goodsname=item.goodsName
        })
        this.goodsCount=res.data.data.goodsCount
        if(this.goodsCount==3){
          this.isShowBtn=true
        }
        if(this.goodsCount < 4 ) {
          this.isShowBtn = true
        }
      }).catch(err=>{
        console.log(err)
      })
    }
  }
 
};
</script>

<style scoped>
.good{
     width:100%;
     height: 100%;
}
.good .bg{
    background: url("../../../assets/images/active/bg/choicegood.png")
    no-repeat left top;
    background-size: cover;
    height:33.35rem;
    position: relative;
    text-align: center;
    display: flex;
    justify-content: center;
    
}
.good .bg .container{
  padding-left:2.125rem;
  padding-right:2.125rem;
  position: absolute;
  top:1.25rem;
  text-align: center;
  
}
.good .bg .container .title{
  width:14.5rem;
  text-align: center;
  font-size:0.95rem;
  font-family:SourceHanSansCN-Bold;
  font-weight:bold;
  color:rgba(255,57,113,1);
}
.good .bg .container .goodslist{
    position: absolute;
    top:2rem;
    width:14.5rem;
    height: 22.5rem;
    /* border:0.025rem solid #ccc; */
}
.good .bg .container .goodslist .box{
  position: relative;
  float: left;
  width:6.5rem;
  height: 6.5rem;
  background:rgba(255,255,255,1);
  border-radius:1.5rem;
  margin-bottom:1.5rem;
  display: flex;
  justify-content: center;
  position: relative;
}
.good .bg .container .goodslist .box .true{
  position: absolute;
  right:0.5rem;
  top:0.5rem;
  width:1rem;
  height: 1rem;
  
}
.good .bg .container .goodslist .box .true img{
  
  width:100%;
  height: 100%;
}
.good .bg .container .goodslist .box .putaway{
  position:absolute;
  background:rgba(255,255,255,1);
  opacity:0.5;
  left:0;
  top:0;
  width:6.5rem;
  height: 6.5rem;
  display: flex;
  justify-content: center;
  border-radius:1.5rem;
}
.good .bg .container .goodslist .box .image{
  position:absolute;
  top:1.425rem;
  width:4.55rem;
  height: 3.65rem;
}
.good .bg .container .goodslist .box .putaway .image img{
  width:100%;
  height: 100%;
}
.good .bg .container .goodslist .box:nth-child(even){
  float: right;
}
.good .bg .container .goodslist .box .img{
  margin-top:1rem;
  /* border:0.025rem solid #ccc; */
  width:3rem;
  height: 3rem;
}
.good .bg .container .goodslist .box .img img{
  width:100%;
  height: 100%;
}
.good .bg .container .goodslist .box .goodsname{
  position:absolute;
  bottom:0.75rem;
  width:4.175rem;
  height: 1.275rem;
  margin:0 auto;
  text-align: center;
}
.good .bg .again{
  width:16rem;
  height:2.2rem;
  line-height: 2.2rem;
  background:rgba(255,255,255,1);
  opacity:0.3;
  border-radius:1.1rem;
  text-align: center;
  font-size:0.85rem;
  font-family:SourceHanSansCN-Regular;
  font-weight:400;
  color:rgba(255,61,115,1);
  position: absolute;
  bottom:5rem;

}
.good .bg .btn{
    position: absolute;
    bottom:1.65rem;
    width:16rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    color:white;
    font-size: 1rem;
}
.good .bg .btn .mocen{
    position: absolute;
    width:16rem;
    height: 3rem;
    left:0;
    top:0;
    /* background:pink; */
  
}
.good .bg .btn .font{
    position: absolute;
    top:0;
    left:0;
    width:16rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    color:white;
    font-size: 1rem;
}
.good .bg .btn img{
    width:100%;
    height: 100%;
}

</style>





// WEBPACK FOOTER //
// src/components/active/view/goods.vue